import React, { useContext, useState } from 'react';
import "../styles/couponInput.css";
import appConst from '../Utilities/appConst.json';
import { LanguageContext } from '../context/language/LanguageContext';
import { useDispatch, useSelector } from 'react-redux';
import { postCouponInput } from '../store/couponsSlice';
import { couponsActions } from '../store/couponsSlice';
import { loaderActions } from '../store/loaderSlice';
import { Input } from './ui/input';

export default function CouponInput() {
  const languageContext = useContext(LanguageContext);
  const dispatch = useDispatch();
  const direction = useSelector((state) => state.mode.direction);

  const alertMessage = useSelector(state => state.coupons.alertMessage);
  const basket = useSelector(state => state.basket.basket);
  const serviceCodeCoupons = useSelector(state => state.coupons.serviceCodeCoupons);
  const collectionBucketCoupons = useSelector(state => state.coupons.collectionBucketCoupons);

  const hasServiceCodeCoupons = serviceCodeCoupons && serviceCodeCoupons.length;
  const hasCollectionBucketCoupons = collectionBucketCoupons && collectionBucketCoupons.length;
  const isSelectionDisabled = !!(hasServiceCodeCoupons || hasCollectionBucketCoupons);
  const [value, setValue] = useState("");

  const hendleOnChange = (event) => {
    setValue(event.target.value);

    if (event.target.value && hasServiceCodeCoupons) {
      dispatch(couponsActions.setAlertMessage({ message: languageContext.getTranslation(appConst.ALERT_COUPON_INPUT_MESSAGE_SERVICE_CODE) }));
    }
    else if (event.target.value && hasCollectionBucketCoupons) {
      dispatch(couponsActions.setAlertMessage({ message: languageContext.getTranslation(appConst.ALERT_COUPON_INPUT_MESSAGE_COLLECTION_BUCKET) }));
    }
    else {
      dispatch(couponsActions.hideAlertMessage());
    }
  }

  const hendleOnClick = () => {
    if (!alertMessage) {
      dispatch(loaderActions.loaderShow());
      dispatch(postCouponInput(value, basket));
      setValue("");
    }
  }

  function handleKeyPress(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      hendleOnClick();
    }
  }

  return (
    <div
      className="coupon_input summary_container"
      dir={direction}
      data-testid="summary-coupon-input"
    >
      <div className="full_dimantions start_position !w-full">
        <form
          className={`paper_coupon_input ${isSelectionDisabled ? 'disabled' : ''}`}
          onSubmit={(event) => {
            event.preventDefault();
            hendleOnClick();
          }}
          data-testid="summary-coupon-input-form"
        >
          <Input
            type="text"
            className='input_coupon_input focus-visible:ring-0 focus-visible:ring-offset-0 placeholder:text-[#9F9F9F]'
            placeholder={languageContext.getTranslation(appConst.COUPON)}
            value={value}
            onChange={hendleOnChange}
            onKeyDown={handleKeyPress}
            dir={direction}
            data-testid="coupon-input-field"
          />
          <button
            type="button"
            className='button_coupon_input border-0'
            onClick={hendleOnClick}
            disabled={isSelectionDisabled}
            data-testid="coupon-approve-button"
          >
            {languageContext.getTranslation(appConst.APPROVE)}
          </button>
        </form>
        {alertMessage &&
          <p className="helper_text_dimantion warning_color warning_font text-start">
            {alertMessage}
          </p>
        }
      </div>
    </div>
  );
}
